import {
    HELPER_RESET,
    HELPER_TRANSACTION_STATUS_ONLOAD,
    HELPER_TRANSACTION_STATUS_SUCCESS,
    HELPER_COMMON1_ONLOAD,
    HELPER_COMMON1_SUCCESS,
    HELPER_COUNTRIES_ONLOAD,
    HELPER_COUNTRIES_SUCCESS,
    HELPER_FLOW_INFO_SUCCESS,
    HELPER_PAYMENT_MODES_ONLOAD,
    HELPER_PAYMENT_MODES_SUCCESS
} from './actions';

const initialState = {
    init: false,
    transactionStatusInit: false,
    transactionStatusLoading: false,
    transactionStatus: [],
    common1Init: false,
    common1Loading: false,
    serviceData: [],
    partnerData: [],
    externalPartnerData: [],
    requestStatusData: [],
    countriesInit: false,
    countriesLoading: false,
    countriesData: [],
    flowInfoList: [],
    flowInfoInit: false,
    paymentModesLoading: false,
    paymentModesInit: false,
    paymentModes: []
}

export function helperReducer(state = initialState, action) {
    let data = action.payload;

    switch (action.type) {
        case HELPER_RESET:
            return {
                ...state,
                init: false,
                transactionStatusInit: false,
                common1Init: false,
            }

        case HELPER_TRANSACTION_STATUS_ONLOAD:
            return {
                ...state,
                transactionStatusLoading: true
            }

        case HELPER_TRANSACTION_STATUS_SUCCESS:
            return {
                ...state,
                transactionStatus: getTransactionStatusList(data),
                transactionStatusLoading: false,
                transactionStatusInit: true,
            }
        case HELPER_COMMON1_ONLOAD:
            return {
                ...state,
                common1Loading: true
            }

        case HELPER_COMMON1_SUCCESS:
            return {
                ...state,
                serviceData: getServiceData(data),
                partnerData: getPartnerData(data),
                externalPartnerData: getExternalPartnerData(data),
                requestStatusData: getRequestStatusData(data),
                common1Loading: false,
                common1Init: true,
            }
            case HELPER_COUNTRIES_ONLOAD:
            return {
                ...state,
                countriesLoading: true
            }

        case HELPER_COUNTRIES_SUCCESS:
            return {
                ...state,
                countriesData: getCountriesData(data),
                countriesLoading: false,
                countriesInit: true,
            }
        case HELPER_PAYMENT_MODES_SUCCESS:
            return {
                ...state,
                paymentModes: getPaymentModesData(data),
                paymentModesLoading: false,
                paymentModesInit: true,
            }
        case HELPER_FLOW_INFO_SUCCESS:
            return {
                ...state,
                flowInfoList: data,
                flowInfoInit: true,
            }

        default:
            return state;
    }
}


const getTransactionStatusList = (data) => {
    return data;
}

const getServiceData = (data) => {
    return data.serviceData;
}

const getPartnerData = (data) => {
    return data.partnerData;
}

const getExternalPartnerData = (data) => {
    return data.externalPartnerData;
}

const getRequestStatusData = (data) => {
    return data.requestStatus
}

const getCountriesData = (data) => {
    return data;
}

const getPaymentModesData = (data) => {
    return data;
}